import { usePartialState } from '@tencent/dz-models';
import { usePageModel } from '@tencent/dz-runtime';
export function useHeaderModel() {
    var model = usePageModel();
    var _a = usePartialState(function () { return model.getHeaderModel(); }), headerInstance = _a[1];
    return headerInstance;
}
